import { createContext, useMemo, useState } from 'react';

import { TData } from '../types/data';

type TDataContext = {
    data: TData[];
    selectedDataItem: TData;
    setSelectedDataItem: (item: TData) => void;
    detailsModalInfo: TData;
    setDetailsModalInfo: (detailsModalInfo: TData) => void;
}

export const DataContext = createContext<TDataContext>(null);

export const DataProvider = ({ children }: React.PropsWithChildren) => {
    const data: TData[] = useMemo(() => {
        return (window as any).data
    }, []);

    const [selectedDataItem, setSelectedDataItem] = useState<TData>(null);

    const [detailsModalInfo, setDetailsModalInfo] = useState<TData>(null);

    const value = {
        data,
        selectedDataItem,
        setSelectedDataItem,
        detailsModalInfo,
        setDetailsModalInfo,
    }

    return (
        <DataContext.Provider value={value}>
            {children}
        </DataContext.Provider>
    )
}